import {Concept} from 'types';
import type {ValidationResult} from 'schema/form/functions/validators/types';
import type {CodeListMap} from 'services/codelists/types';
import {getGetDataBasedSchemaModifiers} from 'schemas/functions';
import type {
  ManifestationStatus,
  Metadata,
  MetadataSchemas,
  MetadataStatuses,
} from '../types';
import {validateEntity} from './validateEntity';

export const validateWork = (
  savedMetadata: Pick<Metadata, 'work'>,
  metadata: Pick<Metadata, 'work'>,
  schemas: MetadataSchemas,
  codelists: CodeListMap,
  statuses: MetadataStatuses,
): {validation: ValidationResult; status: ManifestationStatus} => {
  // Validate work
  const {work: savedWork} = savedMetadata;
  const {work} = metadata;

  const status = statuses[work.id];

  const getDataBasedModifier = getGetDataBasedSchemaModifiers(Concept.work);

  return validateEntity(
    savedWork,
    work,
    {},
    work.type,
    status,
    schemas.work.schema,
    getDataBasedModifier,
    schemas.work.modifiers,
    codelists,
  );
};
